var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextSliderVec({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M21.7412 17.0083L34 15.0631L21.6163 15.9318L33.0926 11.2142L21.25 14.9093L31.3276 7.67286L20.6506 13.999L28.7884 4.63863L19.8639 13.2509L25.6166 2.26944L18.9231 12.7064L21.9868 0.694132L17.8783 12.3905L18.0864 0L16.7919 12.324L14.132 0.220293L15.7221 12.511L10.3357 1.3467L14.7189 12.9391L6.90157 3.31271L13.8448 13.5875L4.01689 6.01858L13.1454 14.4188L1.83154 9.31883L12.6543 15.3873L0.470372 13.0306L12.4003 16.443L0 16.9584L12.3962 17.532L0.449559 20.8863L12.6459 18.5878L1.79407 24.6022L13.133 19.5604L3.96278 27.9149L13.8281 20.3958L6.83913 30.6332L14.7023 21.0443L10.2608 32.62L15.7013 21.4765L14.0529 33.7631L16.7711 21.6719L18.0032 34L17.8575 21.6095L21.9077 33.3225L18.9023 21.302L25.5458 31.768L19.843 20.7575L28.726 29.4112L20.6381 20.0134L31.2818 26.3895L21.2375 19.1073L33.0676 22.8606L21.6121 18.089L33.9875 19.0159L21.7412 17.0083Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextSliderVec);
export default __webpack_public_path__ + "static/media/text-slider-vec.42541633b7ef35f3c1b1687ae70b9cb1.svg";
export { ForwardRef as ReactComponent };